import React from 'react';
import {
  QueryClient,
  QueryClientProvider as ReactQueryClientProvider,
  QueryClientProviderProps,
} from '@tanstack/react-query';
import { ZodError } from 'zod/v3';
import { isApiErrorWithoutErrorsBody } from '../ApiClient';

const throwOnError = (error: unknown) =>
  isApiErrorWithoutErrorsBody(error) || error instanceof ZodError;

const defaultClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 0,
      refetchOnWindowFocus: false,
      retry: false,
      throwOnError,
    },
    mutations: {
      throwOnError,
    },
  },
});

export const QueryClientProvider: React.FC<
  Partial<QueryClientProviderProps>
> = (props) => (
  <ReactQueryClientProvider {...props} client={props.client || defaultClient} />
);
